export enum ProfanityHttpPaths {
  Profanity = '/profanity/rules',
}
